exports.login = function (user) {
  localStorage.eydstoken = user.token
}
exports.logout = function () {
  console.log('Kullanıcı Çıkış Yapıyor')
  localStorage.eydstoken = null
}
exports.numberToAnswer = function (num) {
  if (!num) {
    return 'Boş'
  } else {
    switch (num) {
      case '0':
        return 'A'
      case '1':
        return 'B'
      case '2':
        return 'C'
      case '3':
        return 'D'
      case '4':
        return 'E'
      default :
        return 'Boş'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utility/statics.js